export default class Redirection {
	constructor({
		domain,
		link,
		target,
		url,
		created,
		// Only in retrieve API
		total,
		histogram,
		by_referer: byReferrer,
	}) {
		this._domain = domain;
		this._link = link;
		this._target = target;
		this._url = url;
		this._created = new Date(created);

		this._total = total;
		this._histogramDay = histogram;
		this._byReferrer = byReferrer;
	}

	getURL() {
		return this._url;
	}

	getKey() {
		return this._link;
	}

	toString() {
		return this._url;
	}

	getTarget() {
		return this._target;
	}

	getCreated() {
		return this._created;
	}

	getDomain() {
		return this._domain;
	}

	getLink() {
		return this._link;
	}

	getTotal() {
		return this._total || 0;
	}

	getHistogramDay() {
		return this._histogramDay || [];
	}

	getReferrers() {
		return this._byReferrer || {};
	}
}
